import { api } from '../services/api';
import { fechaHora } from '../nucleo/fechas';
import { linkDelSitio } from '../pwa/compartir';
import { dibujarPlaca } from './placa';
import { PlacaImagen } from './PlacaImagen';
import { disponiblesNoche } from './seccionesPlaca';
import { NOMBRE_APP } from '../marca';

/** La placa de una noche: los partidos, cómo se movió la tabla y los logros. */
export function PlacaNoche({ fecha, onCerrar }: { fecha: string; onCerrar: () => void }) {
  const dia = fechaHora(Date.parse(`${fecha}T15:00:00Z`) / 1000).dia;
  return (
    <PlacaImagen
      tipo="noche"
      archivo={`placa-${fecha}.png`}
      titulo={`${NOMBRE_APP} · ${dia}`}
      descripcion={`Placa de la noche del ${dia}`}
      onCerrar={onCerrar}
      cargar={async () => {
        const noche = await api.noche(fecha);
        if (noche.partidos.length === 0) throw new Error('Esa noche no tiene partidos confirmados.');
        return noche;
      }}
      dibujar={(noche, apagadas) => dibujarPlaca(noche, dia, linkDelSitio(), apagadas)}
      disponibles={disponiblesNoche}
    />
  );
}
